(function () {
  function initDeep(root) {
    if (!root || root.dataset.scenarioDeepInit === 'true') return;
    root.dataset.scenarioDeepInit = 'true';

    var activeSmall = '';
    var roleTitle = root.querySelector('[data-deep-role-title]');
    var roleLead = root.querySelector('[data-deep-role-lead]');
    var proTitle = root.querySelector('[data-deep-pro-title]');
    var proLead = root.querySelector('[data-deep-pro-lead]');
    var accTitle = root.querySelector('[data-deep-acc-title]');
    var accLead = root.querySelector('[data-deep-acc-lead]');
    var addAllLabel = root.dataset.addAllLabel || 'Add all [count] add-ons →';

    function setText(el, value, fallback) {
      if (!el) return;
      var next = (value && String(value).trim()) || fallback || '';
      el.textContent = next;
      el.hidden = !next;
    }

    function applyCopy(smallKey) {
      var copy = root.querySelector('[data-deep-copy][data-small-key="' + smallKey + '"]');
      setText(
        roleTitle,
        copy && copy.dataset.roleTitle,
        'For this activity, use this'
      );
      setText(
        roleLead,
        copy && copy.dataset.roleLead,
        'Different ways to shoot — each with a DJI built for it.'
      );
      setText(proTitle, copy && copy.dataset.proTitle, 'Shot to stand out');
      setText(
        proLead,
        copy && copy.dataset.proLead,
        'Real footage + a dedicated kit — like it, take the whole setup.'
      );
      setText(accTitle, copy && copy.dataset.accTitle, 'Add-ons · Level Up Your Kit');
      // When a Small copy exists, respect blank acc_lead (do not reinject section fallback).
      setText(
        accLead,
        copy ? copy.dataset.accLead || '' : null,
        copy
          ? ''
          : 'The kit already covers the basics — these add-ons unlock more angles and ways to shoot.'
      );
    }

    function syncAddAllScope(scope) {
      if (!scope) return;
      var btn = scope.querySelector('[data-deep-add-all]');
      if (!btn) return;
      var ids = Array.from(scope.querySelectorAll('[data-addon-buy] [data-scenario-atc]'))
        .filter(function (el) {
          return !el.disabled && el.getAttribute('data-available') !== 'false';
        })
        .map(function (el) {
          return (el.getAttribute('data-variant-id') || '').trim();
        })
        .filter(Boolean);
      btn.hidden = ids.length === 0;
      var countLabel = addAllLabel.replace('[count]', String(ids.length));
      var labelEl = btn.querySelector('.scenario-deep__add-all-text');
      if (labelEl) {
        labelEl.textContent = countLabel;
      } else {
        btn.textContent = countLabel;
      }
      btn.dataset.variantIds = ids.join(',');
    }

    function syncAddAll(panel) {
      if (!panel) return;
      var panes = panel.querySelectorAll('[data-deep-kit-pane]');
      if (panes.length) {
        panes.forEach(function (pane) {
          if (!pane.hidden) syncAddAllScope(pane);
        });
        return;
      }
      syncAddAllScope(panel);
    }

    function activateKitTab(panel, productKey) {
      if (!panel || !productKey) return;
      panel.querySelectorAll('[data-deep-kit-tab]').forEach(function (tab) {
        var on = (tab.getAttribute('data-deep-kit-tab') || '') === productKey;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panel.querySelectorAll('[data-deep-kit-pane]').forEach(function (pane) {
        var on = (pane.getAttribute('data-deep-kit-pane') || '') === productKey;
        pane.hidden = !on;
      });
      syncAddAll(panel);
    }

    function showSmall(smallKey) {
      if (!smallKey) return;
      activeSmall = String(smallKey).trim();
      applyCopy(activeSmall);

      var roleCount = 0;
      var productCount = 0;
      var addonVisible = false;

      root.querySelectorAll('[data-deep-item]').forEach(function (item) {
        var key = (item.getAttribute('data-small-key') || item.dataset.smallKey || '').trim();
        var match = key === activeSmall;
        item.hidden = !match;
        if (match) {
          if (item.dataset.deepKind === 'role') roleCount += 1;
          if (item.dataset.deepKind === 'product') productCount += 1;
          if (item.dataset.deepKind === 'addon-panel') {
            addonVisible = true;
            syncAddAll(item);
          }
        } else {
          item.querySelectorAll('video').forEach(function (video) {
            try {
              video.pause();
            } catch (e) {}
          });
        }
      });

      var rolesSection = root.querySelector('.scenario-deep__roles');
      var productsSection = root.querySelector('.scenario-deep__products');
      var accSection = root.querySelector('.scenario-deep__acc');
      if (rolesSection) rolesSection.hidden = roleCount === 0;
      if (productsSection) productsSection.hidden = productCount === 0;
      if (accSection) accSection.hidden = !addonVisible;
      root.hidden = roleCount === 0 && productCount === 0 && !addonVisible;
    }

    root.addEventListener('click', function (event) {
      var kitTab = event.target.closest('[data-deep-kit-tab]');
      if (kitTab && root.contains(kitTab)) {
        event.preventDefault();
        var panel = kitTab.closest('[data-deep-kind="addon-panel"]');
        var key = (kitTab.getAttribute('data-deep-kit-tab') || '').trim();
        if (panel && key) activateKitTab(panel, key);
        return;
      }

      var role = event.target.closest('[data-deep-kind="role"]');
      if (role && root.contains(role)) {
        var targetKey = (role.dataset.scrollTarget || '').trim();
        if (targetKey) {
          var target = root.querySelector(
            '[data-deep-kind="product"][data-product-key="' + targetKey + '"]:not([hidden])'
          );
          if (target) {
            window.scrollTo({
              top: target.getBoundingClientRect().top + window.scrollY - 110,
              behavior: 'smooth'
            });
          }
        }
        return;
      }

      var addAll = event.target.closest('[data-deep-add-all]');
      if (addAll && root.contains(addAll)) {
        event.preventDefault();
        var ids = (addAll.dataset.variantIds || '')
          .split(',')
          .map(function (id) {
            return id.trim();
          })
          .filter(Boolean);
        if (!ids.length || !window.ScenarioCart || typeof window.ScenarioCart.addItems !== 'function') {
          return;
        }
        window.ScenarioCart.addItems({
          items: ids.map(function (id) {
            return { id: id, quantity: 1 };
          }),
          button: addAll,
          source: 'scenario-deep-add-all'
        }).catch(function () {});
      }
    });

    if (window.ScenarioCart && typeof window.ScenarioCart.bindAtcButtons === 'function') {
      window.ScenarioCart.bindAtcButtons(root);
    }

    function onMomentChange(event) {
      var detail = event.detail || {};
      var moment = (detail.effectiveMoment || detail.moment || '').trim();
      if (moment) showSmall(moment);
    }

    function onScenarioChange(event) {
      var detail = event.detail || {};
      var moment = (detail.effectiveMoment || detail.defaultMoment || '').trim();
      if (moment) showSmall(moment);
    }

    if (root._scenarioDeepMomentHandler) {
      document.removeEventListener('scenario:moment-change', root._scenarioDeepMomentHandler);
    }
    if (root._scenarioDeepScenarioHandler) {
      document.removeEventListener('scenario:change', root._scenarioDeepScenarioHandler);
    }
    root._scenarioDeepMomentHandler = onMomentChange;
    root._scenarioDeepScenarioHandler = onScenarioChange;
    document.addEventListener('scenario:moment-change', onMomentChange);
    document.addEventListener('scenario:change', onScenarioChange);

    function bootstrap() {
      try {
        var params = new URLSearchParams(window.location.search);
        var fromUrl = (params.get('moment') || '').trim();
        if (fromUrl) {
          showSmall(fromUrl);
          return;
        }
      } catch (e) {}

      var activeChip = document.querySelector(
        '#scenario-shop [data-scenario-moment].is-active'
      );
      if (activeChip) {
        var selectedKey = (
          activeChip.getAttribute('data-moment-key') ||
          activeChip.dataset.momentKey ||
          ''
        ).trim();
        if (selectedKey) {
          showSmall(selectedKey);
          return;
        }
      }

      var activeTab = document.querySelector('#scenario-shop [data-scenario-tab].is-active');
      if (activeTab) {
        var first = (activeTab.dataset.firstMoment || '').trim();
        if (first) {
          showSmall(first);
          return;
        }
      }

      var firstCopy = root.querySelector('[data-deep-copy][data-small-key]');
      if (firstCopy) showSmall(firstCopy.dataset.smallKey);
    }

    bootstrap();
  }

  function initAll() {
    document.querySelectorAll('[data-scenario-deep]').forEach(initDeep);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section =
      event.target.querySelector('[data-scenario-deep]') ||
      event.target.closest('[data-scenario-deep]');
    if (section) {
      section.dataset.scenarioDeepInit = 'false';
      initDeep(section);
    }
  });
})();
